import { render, staticRenderFns } from "./ModalTambahComponent.vue?vue&type=template&id=6f38276a"
import script from "./ModalTambahComponent.vue?vue&type=script&lang=js"
export * from "./ModalTambahComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports